import { $http } from '@/utils/https';// eslint-disable-next-line
import { globalLoader, fixBody } from '@/helpers/variables/index';
import {
    SET_TOKEN,
    REMOVE_TOKEN,
    CHANGE_POPUP_RESTORE_PASSWORD,
    CHANGE_POPUP_NEW_PASSWORD,
    SET_LOADING_REGISTRATION,
    CHANGE_POPUP_LDAP,
    SING_IN_WITH_LDAP_LOADING,
    CHECK_EMAIL_LOADING,
    SHOW_POPUP_AUTH_LDAP_WARNING
} from '../mutation-types';
import {
    GET_TOKEN,
    REGISTRATION,
    LOGOUT,
    RESTORE_PASSWORD,
    SET_NEW_PASSWORD,
    ACTIVATION_EMAIL,
    SING_IN_WITH_GOGGLE,
    SING_IN_WITH_FACEBOOK,
    SING_IN_WITH_LDAP,
    CHECK_EMAIL
} from '../action-types';

const state = {
    isAuthenticated: false,
    showRestorePassword: false,
    showSetNewPassword: false,
    loadingRegistration: false,
    showPopupLdap: false,
    singInLdapLoading: false,
    popupLdapWarning: false,
    checkEmailLoading: false
};

const getters = {
    isAuthenticated: state => state.isAuthenticated,
    checkEmailLoading: state => state.checkEmailLoading,
    singInLdapLoading: state => state.singInLdapLoading,
    showPopupLdap: state => state.showPopupLdap,
    showRestorePassword: state => state.showRestorePassword,
    showSetNewPassword: state => state.showSetNewPassword,
    singIn: state => state.singIn,
    loadingRegistration: state => state.loadingRegistration,
    popupLdapWarning: state => state.popupLdapWarning
};

const actions = {
    [GET_TOKEN]: async ({commit}, payload) => {
        globalLoader(true);
        try {
            const result = await $http.post('v1/login', payload);
            commit(SET_TOKEN, result.data.access_token);
        } catch (e) {
            throw e;
        } finally {
            globalLoader(false);
        }
    },
    [CHECK_EMAIL]: async ({commit}, payload) => {
        try {
            commit(CHECK_EMAIL_LOADING, true);

            return await $http.post('v1/check_email', payload);
        } catch (e) {
            throw e;
        } finally {
            commit(CHECK_EMAIL_LOADING, false);
        }
    },
    [SING_IN_WITH_GOGGLE]: async ({commit}, payload) => {
        globalLoader(true);
        try {
            const result = await $http.post('v1/oauth/google/login', payload);
            commit(SET_TOKEN, result.data.access_token);
        } catch (e) {
            throw e;
        } finally {
            globalLoader(false);
        }
    },
    [SING_IN_WITH_FACEBOOK]: async ({commit}, payload) => {
        globalLoader(true);
        try {
            const result = await $http.post('v1/oauth/facebook/login', payload);
            commit(SET_TOKEN, result.data.access_token);
        } catch (e) {
            throw e;
        } finally {
            globalLoader(false);
        }
    },
    [SING_IN_WITH_LDAP]: async ({commit}, payload) => {
        commit(SING_IN_WITH_LDAP_LOADING, true)
        try {
            const result = await $http.post('v1/ldap/login', payload);
            commit(SET_TOKEN, result.data.access_token);
        } catch (e) {
            throw e;
        } finally {
            commit(SING_IN_WITH_LDAP_LOADING, false)
        }
    },
    [LOGOUT]: async ({commit}) => {
        try {
            globalLoader(true);

            return await $http.post('v1/logout');
        }catch (e) {
            throw e;
        }finally {
            commit(REMOVE_TOKEN);
            globalLoader(false);
        }
    }, // eslint-disable-next-line
    [REGISTRATION]: async ({commit}, payload) => {
        try {
            commit(SET_LOADING_REGISTRATION, true);

            return await $http.post('v1/register', payload);
        }catch (e) {
            throw e;
        }finally {
            commit(SET_LOADING_REGISTRATION, false);
        }
    },// eslint-disable-next-line
    [RESTORE_PASSWORD]: async ({commit}, payload) => {
        try {
            globalLoader(true);

            return await $http.post('v1/password/restore', payload);
        }catch (e) {
            throw e;
        }finally {
            globalLoader(false);
        }
    },// eslint-disable-next-line
    [SET_NEW_PASSWORD]: async ({commit}, payload) => {
        try {
            globalLoader(true);

            return await $http.post('v1/password/reset', payload);
        }catch (e) {
            throw e;
        }finally {
            globalLoader(false);
        }
    },
    // eslint-disable-next-line
    [ACTIVATION_EMAIL]: async ({commit}, payload) => {
        try {
            globalLoader(true);
            return await $http.post('v1/activation', payload);
        }catch (e) {
            throw e;
        }finally {
            globalLoader(false);
        }
    },
};

const mutations = {
    [SET_TOKEN](state, token) {
        localStorage.setItem('user_token', token);
        state.isAuthenticated = true;
    },
    [REMOVE_TOKEN](state) {
        localStorage.removeItem('user_token');
        window.location.reload();
        state.isAuthenticated = false;
    },
    [CHANGE_POPUP_RESTORE_PASSWORD](state, status) {
        state.showRestorePassword = status;
        fixBody(status)
    },
    [CHECK_EMAIL_LOADING](state, status) {
        state.checkEmailLoading = status;
    },
    [SET_LOADING_REGISTRATION](state, status) {
        state.loadingRegistration = status;
    },
    [CHANGE_POPUP_NEW_PASSWORD](state, status) {
        state.showSetNewPassword = status;
        fixBody(status)
    },
    [CHANGE_POPUP_LDAP](state, status) {
        state.showPopupLdap = status;
        fixBody(status)

    },
    [SING_IN_WITH_LDAP_LOADING](state, status) {
        state.singInLdapLoading = status;
    },
    [SHOW_POPUP_AUTH_LDAP_WARNING](state, status) {
        state.popupLdapWarning = status;
        if(!status){
            state.showPopupLdap = !status
            fixBody(!status)
            return false;
        }
        fixBody(status)
    },
};
export default {
    state,
    getters,
    actions,
    mutations,
};
